import { Container, Row, Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";

const Rawintegrate = () => {
  return (
    <>
      <Container>
        <div className="screenHeight">
          <Shopintegrate
            newshop="/raw-material-form"
            url="/raw-integrate-form"
          />
        </div>
      </Container>
    </>
  );
};

export default Rawintegrate;
